// src/main.jsx
import React from 'react'
import ReactDOM from 'react-dom/client'
import FeedbackWidget from './FeedbackWidget'
import './FeedbackWidget.css'

// Global function to initialize the widget
window.InitializeFeedbackWidget = function (config = {}) {
  const {
    containerId = 'feedback-widget-root',
    apiEndpoint = '/api/public/SendFeedBack',
    screenshotUrl = 'https://api.alphadezine.com/fullpage-ss',
    devUrl = 'https://localhost:7211',
    onlyDevMode = false
  } = config;

  // Check if dev mode check should be applied
  if (onlyDevMode) {
    const origin = window?.location?.origin
    if (!origin.includes('-dev.azure') && !origin.includes('localhost') && !origin.includes('127.0.0.1')) {
      console.log('FeedbackWidget: Not in dev mode, skipping initialization.')
      return
    }
  }

  let container = document.getElementById(containerId)

  if (!container) {
    container = document.createElement('div')
    container.id = containerId
    document.body.appendChild(container)
  }

  const root = ReactDOM.createRoot(container)
  root.render(
    <React.StrictMode>
      <FeedbackWidget
        apiEndpoint={apiEndpoint}
        screenshotUrl={screenshotUrl}
        devUrl={devUrl}
      />
    </React.StrictMode>
  )
}

// Function to detect and parse data attributes from the script tag (FIXED LOGIC)
function autoInitialize() {
  const scriptTag = document.querySelector(`script[src*="feedback-widget.umd.js"]`);

  if (!scriptTag) {
    console.warn('FeedbackWidget: Could not find script tag for auto-initialization.');
    return;
  }

  if (scriptTag.dataset.autoInit === 'true') {
    const config = {};

    if (scriptTag.dataset.apiEndpoint) {
      config.apiEndpoint = scriptTag.dataset.apiEndpoint;
    }

    if (scriptTag.dataset.screenshotUrl) {
      config.screenshotUrl = scriptTag.dataset.screenshotUrl;
    }

    if (scriptTag.dataset.devUrl) {
      config.devUrl = scriptTag.dataset.devUrl;
    }

    if (scriptTag.dataset.devMode !== undefined) {
      config.onlyDevMode = scriptTag.dataset.devMode !== 'false';
    }

    window.InitializeFeedbackWidget(config);
  }
}


// Auto-initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', autoInitialize)
} else {
  // DOM is already loaded
  autoInitialize()
}

// Export as default
export default FeedbackWidget